import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export default function useGasData(location, product, radius, brand) {
  const [stations, setStations] = useState([]);
  const [trends, setTrends] = useState([]);
  const [products, setProducts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch available products and brands on mount
  useEffect(() => {
    axios.get(`${API_BASE}/trends/products`)
      .then(res => setProducts(res.data))
      .catch(() => {});
    axios.get(`${API_BASE}/trends/brands`)
      .then(res => setBrands(res.data))
      .catch(() => {});
  }, []);

  // Fetch nearby stations when location/product/radius/brand changes
  const fetchStations = useCallback(async () => {
    if (!location) return;
    setLoading(true);
    setError(null);
    try {
      const params = {
        lat: location.lat,
        lng: location.lng,
        radius,
      };
      if (product) params.product = product;
      if (brand) params.brand = brand;

      const res = await axios.get(`${API_BASE}/stations/nearby`, { params });
      setStations(res.data.stations);
    } catch (err) {
      setError('Erro ao buscar postos próximos');
      setStations([]);
    } finally {
      setLoading(false);
    }
  }, [location, product, radius, brand]);

  // Fetch price trends
  const fetchTrends = useCallback(async () => {
    if (!location || !product) return;
    try {
      const params = {
        lat: location.lat,
        lng: location.lng,
        radius,
        product,
      };
      if (brand) params.brand = brand;
      const res = await axios.get(`${API_BASE}/trends`, { params });
      setTrends(res.data.trends);
    } catch {
      setTrends([]);
    }
  }, [location, product, radius, brand]);

  useEffect(() => {
    fetchStations();
    fetchTrends();
  }, [fetchStations, fetchTrends]);

  return { stations, trends, products, brands, loading, error, refetch: fetchStations };
}
